import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import AdminTable from 'common/AdminTable';
import { getRequest, postRequest } from 'apis/ApiInstence';

const Announcements = () => {
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [audience, setAudience] = useState('customer');
    const [sending, setSending] = useState(false);
    const [history, setHistory] = useState([]);

    const loadHistory = async () => {
        const res = await getRequest('announcements');
        if (res?.status) {
            setHistory(res.data);
        } else {
            toast.error('Failed to load announcements!');
        }
    };

    useEffect(() => {
        loadHistory();
    }, []);

    const handleSend = async () => {
        if (!title.trim() || !message.trim()) {
            toast.error('Please enter a title and a message.');
            return;
        }

        setSending(true);
        try {
            const res = await postRequest('announcements', { title, message, audience });
            if (res?.status === 201) {
                toast.success(`Announcement sent to ${res.data.sent_count} device(s)!`);
                setTitle('');
                setMessage('');
                loadHistory();
            } else {
                toast.error('Failed to send announcement!');
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to send announcement!');
        }
        setSending(false);
    };

    const tableHeaders = [
        { Header: 'Title', accessor: 'title' },
        {
            Header: 'Message',
            accessor: 'message',
            Cell: ({ row }) => (
                <span>
                    {row.original.message?.length > 80
                        ? `${row.original.message.slice(0, 80)}…`
                        : row.original.message}
                </span>
            ),
        },
        {
            Header: 'Audience',
            accessor: 'audience',
            Cell: ({ row }) =>
                row.original.audience === 'all'
                    ? 'Customers + Servicemen'
                    : row.original.audience === 'serviceman'
                        ? 'Servicemen'
                        : 'Customers',
        },
        { Header: 'Devices Reached', accessor: 'sent_count' },
        { Header: 'Sent At', accessor: 'createdAt' },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Announcements</h4>
            </div>

            <div className="mx-4 mb-4 p-3 bg-light rounded">
                <div className="form-group">
                    <label htmlFor="announcementTitle">Title</label>
                    <input
                        type="text"
                        id="announcementTitle"
                        className="form-control"
                        placeholder="e.g. New service launched!"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="announcementMessage">Message</label>
                    <textarea
                        id="announcementMessage"
                        className="form-control"
                        rows={4}
                        placeholder="What do you want to tell them?"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="announcementAudience">Send To</label>
                    <select
                        id="announcementAudience"
                        className="form-control"
                        value={audience}
                        onChange={(e) => setAudience(e.target.value)}
                    >
                        <option value="customer">Customers</option>
                        <option value="serviceman">Servicemen</option>
                        <option value="all">Both</option>
                    </select>
                </div>
                <button className="btn btn-primary" disabled={sending} onClick={handleSend}>
                    {sending ? 'Sending…' : 'Send Announcement'}
                </button>
            </div>

            {history.length > 0 ? (
                <AdminTable tableHeaders={tableHeaders} tableData={history} />
            ) : (
                <div className="bg-danger p-2 mx-4 text-white">No announcements sent yet.</div>
            )}
        </div>
    );
};

export default Announcements;
